import FormattedDateTime from 'I18n/components/FormattedDateTime';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UISection from 'UIComponents/section/UISection';
import UIList from 'UIComponents/list/UIList';
import Rating from 'marketplace-ui-reviews/components/Rating';
import ReviewBody from 'marketplace-ui-reviews/components/ReviewBody';
import ReviewerInfo from 'marketplace-ui-reviews/components/ReviewerInfo';
import ReviewReplyThread from 'marketplace-ui-reviews/components/ReviewReplyThread';
import { RatingAxes } from 'marketplace-ui-reviews/constants/RatingAxes';
import { GREAT_WHITE } from 'HubStyleTokens/colors';
// @ts-expect-error untyped dependency
import withReportModalState from './withReportModalState';

// Renders a complete review item given a review. ReviewsList iterates through
// a list of reviews and calls the Renderer to display each one
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function DetailsReviewRenderer({
  borderBottom,
  isCustomer,
  onReplyModalOpen,
  review,
  reviewModalOpen,
  replyModalOpen,
  reportReviewModal,
  reportReplyModal,
  reviewActionsList,
  searchTerm,
  showOriginal
}) {
  const rating = showOriginal ? review.get('original').ratings.get(RatingAxes.OVERALL) : review.getIn(['ratings', RatingAxes.OVERALL]);
  return /*#__PURE__*/_jsxs("div", {
    className: "p-y-8",
    style: {
      minWidth: '300px',
      width: '100%',
      borderBottom: borderBottom ? `1px solid ${GREAT_WHITE}` : undefined
    },
    children: [/*#__PURE__*/_jsx(UISection, {
      children: /*#__PURE__*/_jsx(Rating, {
        direction: "column",
        label: /*#__PURE__*/_jsxs(UIList, {
          inline: true,
          use: "inline-divided",
          children: [/*#__PURE__*/_jsx(FormattedDateTime, {
            value: review.get('createdAt'),
            format: "ll",
            type: "userTz"
          }), review.get('lastEditedAt') && /*#__PURE__*/_jsxs("span", {
            children: [/*#__PURE__*/_jsx(FormattedMessage, {
              className: "m-right-1",
              message: "appMarketplace.detail.reviews.edit.edited"
            }), /*#__PURE__*/_jsx(FormattedDateTime, {
              value: review.get('lastEditedAt'),
              format: "ll",
              type: "userTz"
            })]
          })]
        }),
        rating: rating,
        showTextRating: true
      })
    }), /*#__PURE__*/_jsx(ReviewBody, {
      review: review,
      searchTerm: searchTerm,
      showOriginal: showOriginal
    }), /*#__PURE__*/_jsx(ReviewerInfo, {
      inline: true,
      review: review
    }), reviewActionsList, /*#__PURE__*/_jsx(ReviewReplyThread, {
      reply: review.get('reply'),
      onReportReplyClick: isCustomer ? onReplyModalOpen : undefined
    }), reviewModalOpen && reportReviewModal, replyModalOpen && reportReplyModal]
  });
}
export default withReportModalState(DetailsReviewRenderer);